// extracted by mini-css-extract-plugin
module.exports = {"container":"_21hZ_dBmEPz3qNEwt1O591","closeIcon":"_1nPuoWprZpOG89nu7mPECT"};